/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectAll/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ChoiceToggle from 'DesignSystem/ChoiceToggle/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SelectAll({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/LocationChooser/Content/Many/SelectAll",
  isSelected
  
}) {
let selectedLocationsLengthValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'locations.length',
})
let locationsLengthValueData = fromData.useDataValue({ viewPath,
context: 'locations',
path: 'length',
})
let aggregateData = fromAggregate.equals(selectedLocationsLengthValueData, locationsLengthValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSelected
  
})
  return (<React.Fragment
>
<div
  data-testid="SelectAll.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ChoiceToggle
  viewPath={`${viewPath}/ChoiceToggle`}
 text={isSelected ? "None" : "All"}
 data="selected.locations.length"
 data="locations.length"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 width={55}
 paddingBottom={4}
 paddingTop={4}
/>
</div>
{children}
</React.Fragment>)
}